<template>
  <div class="container">
    <div class="help-title">
      <span>{{ $t("help.lookupTitle") }}</span>
    </div>
    <div class="guide-container shadow">
      <div>
        <div class="help-title">
          <span>{{ $t("help.lookupInfo") }}</span>
        </div>
        <div class="help-info">
          <img src="../../assets/help-icon-00.png" />
          <span>{{ $t("help.lookupOption1") }}</span>
        </div>
        <div class="help-info">
          <img src="../../assets/help-icon-00.png" />
          <span>{{ $t("help.lookupOption2") }}</span>
        </div>
        <div class="help-info">
          <img src="../../assets/help-icon-00.png" />
          <span>{{ $t("help.lookupOption3") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "./help-page.scss";
</style>
